import React from 'react';
import {
  AlertDanger,
  CancelFailLineIcon,
  Dialog,
  DialogBackdrop,
  DialogContent,
  DialogFooter,
  PrimaryButton,
  TertiaryButton,
} from '@tricor-digital-team/vistra-design-system';

const PaymentFailure = ({ dialog, handleTryAgain }) => {
  return (
    <DialogBackdrop id="dialog-backdrop" {...dialog} style={{ zIndex: 1200 }}>
      <Dialog
        id="dialog-container"
        hideOnEsc={false}
        hideOnClickOutside={false}
        {...dialog}
        aria-label="Example Label"
        size={'medium'}
        style={{ zIndex: 1300 }}
      >
        <DialogContent>
          <div className="flex items-center gap-2 pb-8">
            <CancelFailLineIcon className="text-red-600 text-2xl" />
            <div className="text-black text-2xl font-semibold" tabIndex={1}>
              Failed to submit application
            </div>
          </div>
          <AlertDanger title="Something went wrong">
            <p>Try again or if the problem persists, click here to contact Vistra support.</p>
          </AlertDanger>
        </DialogContent>
        <DialogFooter>
          <div className="flex justify-between items-center w-full py-3">
            <TertiaryButton label="Back" onClick={() => dialog.hide()} size="large" />
            <PrimaryButton label="Try again" onClick={handleTryAgain} size="large" />
          </div>
        </DialogFooter>
      </Dialog>
    </DialogBackdrop>
  );
};
export default PaymentFailure;
